import React, { FC, PropsWithChildren } from 'react';
import { PrepareTestData } from '@/components/Admin/AdminTools/PrepareTestData/PrepareTestData';
import { UpdateDomainUrls } from '@/components/Admin/AdminTools/UpdateDomainUrls/UpdateDomainUrls';
import { ImportCmpData } from '@/components/Admin/AdminTools/ImportCmpData/ImportCmpData';
import { Box, SxProps } from '@mui/material';
import { mergeSx } from '@/utils/mergeSx';
import { ReindexPagesWidget } from '@/views/DashboardView/widgets/ReindexPagesWidget';
import { Settings } from '@/Settings';

const AdminToolsGrid: FC<PropsWithChildren> = ({ children }) => {
  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: 'repeat(5, 1fr)',
        gridTemplateRows: 'auto repeat(auto-fill, 150px)',
        gridGap: '24px',
        width: '100%',
      }}>
      {children}
    </Box>
  );
};

const GridItem: FC<
  PropsWithChildren<{
    sx?: SxProps;
  }>
> = ({ children, sx }) => {
  return (
    <Box
      sx={mergeSx(
        {
          height: '100%',
        },
        sx ?? {},
      )}>
      {children}
    </Box>
  );
};

export const AdminToolsView: FC = () => {
  return (
    <AdminToolsGrid>
      {!['production', 'preprod'].includes(Settings.getViteEnvironment) && (
        <GridItem>
          <PrepareTestData />
        </GridItem>
      )}
      {!Settings.viteEnvironmentIsProduction && (
        <GridItem>
          <UpdateDomainUrls />
        </GridItem>
      )}
      <GridItem>
        <ReindexPagesWidget />
      </GridItem>
      <GridItem>
        <ImportCmpData />
      </GridItem>
    </AdminToolsGrid>
  );
};
